<template>
  <div class="Reports__View">
    <EntityListLayout :tabs="tabs" ref="entity" @onNewEntitySave="onNewEntitySave">
      <template #title>דוחות</template>
      <template #button>
        <!-- <b-button @click="showNewEntity">הוספת דוח חדש</b-button> -->
        <a @click="addTask" class="link-button">
          משימה חדשה
        </a>
        <router-link class="link-button" to="/addreport">
          הוספת דוח חדש
        </router-link>
      </template>
      <template v-slot:counter="slotProps">
        סה"כ <b>{{ getTotalRecords(slotProps) }} </b>
      </template>
    </EntityListLayout>
  </div>
</template>
<script>
import ReportService from "@/services/ReportService";
import ProfileService from "@/services/ProfileService";
import EntityListLayout from "@/components/EntityListLayout.vue";
import AdminReportEntity from "@/views/AdminReportEntity.vue";
import DialogAddTask from '@/components/DialogAddTask.vue';
import {
  ModalProgrammatic as Modal,
} from 'buefy';
import TableActions from "@/services/TableActionsService";
import FieldService from "@/services/FieldService";
import VehicleService from "@/services/VehicleService";
import FilterService from "@/services/FilterService";
import NewReportEntity from "@/components/Entities/NewReportEntity.vue";
import { saveAs } from "file-saver";

export default {
  name: "AdminSearchReports",
  data() {
    return {
      tabs: [],
    };
  },
  components: {
    EntityListLayout,
  },
  computed: {
    isAdmin() {
      return this.$store.state.auth?.user?.claims?.isAdmin === "True";
    },
    adminDateTypeOptions() {
      return [
        ...FilterService.list().DateTypes.Options,
        { ...FilterService.DateSearchTypes.LastSendingDate },
        { ...FilterService.DateSearchTypes.LastDriverSendingDate },
      ];
    },
    tabName() {
      return this.selectedTab && this.selectedTab.title;
    },
    excelMimeType() {
      return "application/vnd.ms-excel";
    },
    isLeasingCompany() {
      return this.$store.state.profile?.IsLeasingCompany;
    },
    isReady() {
      return this.isLeasingCompany === null;
    },
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      const reportsFields = FieldService.list("reports");
      const reportsfilters = FilterService.list();

      const sideViewEntity = {
        component: AdminReportEntity,
        preview: true,
        readOnly: false,
        title: "פרטי דוח",
        recordUrl: "admin/reports",
      };

      const excelExport = [
        {
          title: "יצוא טבלה",
          action: this.export,
        },
        // {
        //   title: "יצוא מקובץ לפי עיריות",
        //   action: this.exportByMunic,
        // },
        // {
        //   title: "יצוא מקובץ לפי לקוח",
        //   action: this.exportByClient,
        // },
      ];
      const fields = [
        { ...reportsFields.Address, checked: false },
        { ...reportsFields.Alerts, checked: true },
        { ...reportsFields.ApprovalDate, checked: false },
        { ...reportsFields.ClientComment, checked: false },
        { ...reportsFields.CreateDate, checked: false },
        { ...reportsFields.CurrentAmount, checked: true },
        { ...reportsFields.DateTaken, checked: true },
        { ...reportsFields.Driver, checked: false },
        { ...reportsFields.DriverAmount, checked: false },
        { ...reportsFields.DriverTransferCompleteDate, checked: false },
        { ...reportsFields.DriverTransferError, checked: false },
        { ...reportsFields.DriverTransferPdfUrl, checked: true },
        { ...reportsFields.DriverTransferSignedDate, checked: false },
        { ...reportsFields.DriverTransferStatus, checked: false },
        { ...reportsFields.DriverTransferredDate, checked: false },
        { ...reportsFields.LastDriverSendingDate, checked: false },
        { ...reportsFields.HasScreenshot, checked: false },
        { ...reportsFields.IsPaid, checked: false },
        { ...reportsFields.IsPaidByDriver, checked: false },
        { ...reportsFields.LastPayDate, checked: true },
        { ...reportsFields.ManagerComment, checked: false },
        { ...reportsFields.MuniIdNumber, checked: false },
        { ...reportsFields.MuniReferenceNumber, checked: false },
        { ...reportsFields.Municipality, checked: true },
        { ...reportsFields.OriginalAmount, checked: true },
        // { ...reportsFields.OwnerName, checked: false }, // TransferredFromName
        { ...reportsFields.PartialPaidAmount, checked: false },
        { ...reportsFields.PaymentDate, checked: false },
        { ...reportsFields.PaymentReferenceNumber, checked: false },
        { ...reportsFields.PaymentUrl, checked: true },
        {
          ...reportsFields.PlateNumber,
          checked: true,
          onClick: this.onPlateNumberClick,
          isAdmin: true
        },
        // { ...reportsFields.Profile, checked: true }, // TransferredTo
        { ...reportsFields.Reason, checked: false },
        { ...reportsFields.RelevantLaw, checked: false },
        { ...reportsFields.ReportCause, checked: false },
        { ...reportsFields.ReportNumber, checked: true, isAdmin: true },
        { ...reportsFields.Status, checked: true },
        { ...reportsFields.TransferCompleteDate, checked: false },
        { ...reportsFields.TransferError, checked: false },
        // { ...reportsFields.TransferPdfUrl, checked: true },
        { ...reportsFields.TransferSignedDate, checked: false },
        { ...reportsFields.TransferStatus, checked: false },
        { ...reportsFields.TransferredDate, checked: false },
        { ...reportsFields.LastSendingDate, checked: false },
        { ...reportsFields.VehicleType, checked: true },
        { ...reportsFields.VerificationDate, checked: false },
      ];

      const reportFields = [
        ...fields,
        { ...reportsFields.OwnerName, checked: false },
        { ...reportsFields.ProfileName, checked: true },
        { ...reportsFields.TransferPdfUrl, checked: true },
        { ...reportsFields.TransferReference, checked: true },
        { ...reportsFields.TransferBotError, checked: true },
        { ...reportsFields.DriverTransferReference, checked: true },
        { ...reportsFields.DriverTransferBotError, checked: true },
      ];
      const transfersFields = [
        ...fields,
        { ...reportsFields.TransferredFromName, checked: false },
        { ...reportsFields.TransferredTo, checked: true, onClick: { } },
        { ...reportsFields.TransferPdfUrlAdmin, checked: true },
        { ...reportsFields.TransferReference, checked: true },
        { ...reportsFields.TransferBotError, checked: true },
        { ...reportsFields.DriverTransferReference, checked: true },
        { ...reportsFields.DriverTransferBotError, checked: true },
      ];

      const allReportFields = [
        ...fields,
        { ...reportsFields.CompanyOwnerName, checked: false },
        { ...reportsFields.ProfileName, checked: true },
        { ...reportsFields.TransferPdfUrl, checked: true },
        { ...reportsFields.TransferReference, checked: true },
        { ...reportsFields.TransferBotError, checked: true },
        { ...reportsFields.DriverTransferReference, checked: true },
        { ...reportsFields.DriverTransferBotError, checked: true },
      ];

      this.tabs = [
        {
          id: "AllReportsAdmin",
          title: "כל הדוחות",
          newEntityComponent: NewReportEntity,
          getDataAsync: this.getAllReports,
          perPage: 20,
          fields: allReportFields,
          filters: [
            { ...reportsfilters.IsPaid },
            { ...reportsfilters.ReportStatus },
            { ...reportsfilters.NotReportStatus },
            { ...reportsfilters.Reason },
            { ...reportsfilters.Alerts },
            {
              ...reportsfilters.Profile,
              OptionsAsync: ProfileService.allMapped,
              isTransferOnly: false,
              searchRemote: true
            },
            { ...reportsfilters.Driver },
            {
              ...reportsfilters.VehicleOwner,
              OptionsAsync: ProfileService.allMapped,
            },
            { ...reportsfilters.TransferStatusWNotTransferred },
            {
              ...reportsfilters.DriverTransferStatusWNotTransferred,
              Display: "סטטוס הסבת עובד",
              Query: "DriverTransferStatus",
              Tooltip: 'סטטוס ההסבה של עובד ע"פ המערכת',
            },
            { ...reportsfilters.ReportNumber },
            { ...reportsfilters.MuniIdNumber },
            { ...reportsfilters.PostOfficeReference },
            {
              ...reportsfilters.PlateNumber,
              selected: this.$route.query.PlateNumber,
              OptionsAsync: (term) =>
                VehicleService.searchAdminPlateNumber(term).then((r) =>
                  r.data.map((s) => ({ Text: s.Name, Value: s.Name }))
                ),
            },
            { ...reportsfilters.Municipality },
            {
              ...reportsfilters.DateTypes,
              selected: FilterService.DateSearchTypes.DateTaken,
              Options: this.isLeasingCompany
                ? this.adminDateTypeOptions
                : [
                  { ...FilterService.DateSearchTypes.DateTaken },
                  { ...FilterService.DateSearchTypes.LastPayDate },
                  { ...FilterService.DateSearchTypes.PaymentDate },
                  { ...FilterService.DateSearchTypes.ApprovalDate },
                  { ...FilterService.DateSearchTypes.VerificationDate },
                  { ...FilterService.DateSearchTypes.CreateDate },
                  {
                    ...FilterService.DateSearchTypes
                      .FirstDocumentTransferCompleteDate,
                  },
                  {
                    ...FilterService.DateSearchTypes
                      .FirstDocumentTransferDriverCompleteDate,
                  },
                ],
            },
          ],
          sortField: "LastPayDate",
          sortOrder: "desc",
          checkableRows: true,
          excelExport,
          fastSearch: true,
          fastSearchOptions: {
            propName: "ReportNumber",
            label: "חיפוש לפי מספר דוח",
          },
          sideViewEntity,
          tableActions: [
            TableActions.markAsPaid,
            TableActions.driverAssign,
            TableActions.addTask,
            TableActions.downloadFiles,
            // {
            //   ...TableActions.changeTransferStatusCompany,
            //   Label: "שינוי סטטוס הסבת לקוח TEST",
            // },
            {
              ...TableActions.changeTransferStatusDriver,
              Label: "שינוי סטטוס הסבת עובד",
            },
            TableActions.changeReportStatus,
            TableActions.reportsDetailsScanning,
            TableActions.reportsAlertsGenerator,
          ],
          isAdminArea: true,
          defaultQuery: false
          // defaultQuery: {
          //   IsAscending: false,
          //   SortedBy: "LastPayDate"
          // }
        },
        {
          id: "PaymentVerificationAdmin",
          title: "וידוא תשלום",
          newEntityComponent: NewReportEntity,
          getDataAsync: ({ cancelToken, setPermanentQuery, ...rest }) => {
            const query = rest;
            return this.getAllTransfers({ cancelToken, ...query });
          },
          perPage: 20,
          fields: transfersFields,
          isTransferContext: true,
          filters: [
            { ...reportsfilters.IsPaid, selected: true },
            { ...reportsfilters.ReportStatus },
            { ...reportsfilters.NotReportStatus },
            { ...reportsfilters.Reason },
            { ...reportsfilters.Alerts },
            {
              ...reportsfilters.Profile,
              OptionsAsync: ProfileService.allMapped,
              isTransferOnly: false,
              searchRemote: true
            },
            { ...reportsfilters.Driver },
            {
              ...reportsfilters.VehicleOwner,
              OptionsAsync: ProfileService.allMapped,
            },
            {
              ...reportsfilters.TransferStatusWNotTransferred,
              selected: [
                1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 18, 19, 24
              ],
            },
            {
              ...reportsfilters.DriverTransferStatusWNotTransferred,
              Display: "סטטוס הסבת עובד",
              Query: "DriverTransferStatus",
              Tooltip: 'סטטוס ההסבה של עובד ע"פ המערכת',
            },
            { ...reportsfilters.ReportNumber },
            { ...reportsfilters.MuniIdNumber },
            { ...reportsfilters.PostOfficeReference },
            {
              ...reportsfilters.PlateNumber,
              selected: this.$route.query.PlateNumber,
              OptionsAsync: (term) =>
                VehicleService.searchAdminPlateNumber(term).then((r) =>
                  r.data.map((s) => ({ Text: s.Name, Value: s.Name }))
                ),
            },
            { ...reportsfilters.Municipality },
            {
              ...reportsfilters.DateTypes,
              selected: FilterService.DateSearchTypes.DateTaken,
              Options: this.isLeasingCompany
                ? this.adminDateTypeOptions
                : [
                  { ...FilterService.DateSearchTypes.DateTaken },
                  { ...FilterService.DateSearchTypes.LastPayDate },
                  { ...FilterService.DateSearchTypes.PaymentDate },
                  { ...FilterService.DateSearchTypes.ApprovalDate },
                  { ...FilterService.DateSearchTypes.VerificationDate },
                  { ...FilterService.DateSearchTypes.CreateDate },
                  {
                    ...FilterService.DateSearchTypes
                      .FirstDocumentTransferCompleteDate,
                  },
                  {
                    ...FilterService.DateSearchTypes
                      .FirstDocumentTransferDriverCompleteDate,
                  },
                ],
            },
          ],
          sortField: "LastPayDate",
          sortOrder: "asc",
          checkableRows: true,
          excelExport,
          fastSearch: true,
          fastSearchOptions: {
            propName: "ReportNumber",
            label: "חיפוש לפי מספר דוח",
          },
          sideViewEntity,
          tableActions: [
            TableActions.verifiedPayment,
            TableActions.markAsPaid,
            TableActions.driverAssign,
            {
              ...TableActions.changeTransferStatusCompanyAdmin,
              Label: "שינוי סטטוס הסבת לקוח",
            },
            {
              ...TableActions.changeTransferStatusDriver,
              Label: "שינוי סטטוס הסבת עובד",
            },
            TableActions.changeReportStatus,
            TableActions.reportsDetailsScanning,
            TableActions.reportsAlertsGenerator,
          ],
          isAdminArea: true,
          defaultQuery: false
          // defaultQuery: {
          //   IsAscending: true,
          //   SortedBy: "LastPayDate",
          //   TransferStatus: [1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 18, 19],
          //   tab: "PaymentVerificationAdmin"
          // }
        },
        {
          id: "AllTransferCompanySendingProcessAdmin",
          title: "כל ההסבות",
          newEntityComponent: NewReportEntity,
          getDataAsync: this.getAllTransfers,
          perPage: 20,
          // fields,
          fields: this.displayFields(
            transfersFields,
            [
              "סטטוס הסבת לקוח",
              "תאריך הפקת הסבת לקוח",
              "קובץ הסבה ללקוח",
              "חברה",
              "לקוח",
            ],
            ["סטטוס הסבת עובד", "תאריך הפקת הסבת עובד", "קובץ הסבת עובד", "עובד"]
          ),
          isTransferContext: true,
          filters: [
            { ...reportsfilters.IsPaid },
            { ...reportsfilters.ReportStatus },
            { ...reportsfilters.NotReportStatus },
            { ...reportsfilters.Reason },
            { ...reportsfilters.Alerts },
            {
              ...reportsfilters.Profile,
              OptionsAsync: ProfileService.allMapped,
              isTransferOnly: false,
              searchRemote: true
            },
            { ...reportsfilters.Driver },
            {
              ...reportsfilters.VehicleOwner,
              OptionsAsync: ProfileService.allMapped,
            },
            {
              ...reportsfilters.TransferStatusWNotTransferred,
              selected: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 24, 26],
            },
            {
              ...reportsfilters.DriverTransferStatusWNotTransferred,
              Display: "סטטוס הסבת עובד",
              Query: "DriverTransferStatus",
              Tooltip: 'סטטוס ההסבה של עובד ע"פ המערכת',
            },
            { ...reportsfilters.ReportNumber },
            { ...reportsfilters.MuniIdNumber },
            { ...reportsfilters.PostOfficeReference },
            {
              ...reportsfilters.PlateNumber,
              selected: this.$route.query.PlateNumber,
              OptionsAsync: (term) =>
                VehicleService.searchAdminPlateNumber(term).then((r) =>
                  r.data.map((s) => ({ Text: s.Name, Value: s.Name }))
                ),
            },
            { ...reportsfilters.Municipality },
            {
              ...reportsfilters.DateTypes,
              selected: FilterService.DateSearchTypes.DateTaken,
              Options: this.isLeasingCompany
                ? this.adminDateTypeOptions
                : [
                  { ...FilterService.DateSearchTypes.DateTaken },
                  { ...FilterService.DateSearchTypes.LastPayDate },
                  { ...FilterService.DateSearchTypes.PaymentDate },
                  { ...FilterService.DateSearchTypes.ApprovalDate },
                  { ...FilterService.DateSearchTypes.VerificationDate },
                  { ...FilterService.DateSearchTypes.CreateDate },
                  {
                    ...FilterService.DateSearchTypes
                      .FirstDocumentTransferCompleteDate,
                  },
                  {
                    ...FilterService.DateSearchTypes
                      .FirstDocumentTransferDriverCompleteDate,
                  },
                ],
            },
          ],
          sortField: "LastPayDate",
          sortOrder: "asc",
          checkableRows: true,
          excelExport,
          fastSearch: true,
          fastSearchOptions: {
            propName: "ReportNumber",
            label: "חיפוש לפי מספר דוח",
          },
          sideViewEntity,
          tableActions: [
            TableActions.markAsPaid,
            TableActions.driverAssign,
            TableActions.downloadFiles,
            TableActions.addTask,
            {
              ...TableActions.changeTransferStatusCompanyAdmin,
              Label: "שינוי סטטוס הסבת לקוח",
            },
            {
              ...TableActions.changeTransferStatusDriver,
              Label: "שינוי סטטוס הסבת עובד",
            },
            TableActions.changeReportStatus,
            TableActions.reportsDetailsScanning,
            TableActions.reportsAlertsGenerator,
          ],
          isAdminArea: true,
          defaultQuery: false
          // defaultQuery: {
          //   IsAscending: true,
          //   SortedBy: "LastPayDate",
          //   TransferStatus: [1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 18, 19],
          //   tab: "AllTransferCompanySendingProcessAdmin"
          // }
        },
        {
          id: "ReportsTransferCompanyViaMail",
          title: "דוחות ממתינים לשליחה בדואר לפי סטטוס הסבת לקוח",
          newEntityComponent: NewReportEntity,
          getDataAsync: this.getAllTransfers,
          perPage: 20,
          fields: transfersFields,
          isTransferContext: true,
          filters: [
            { ...reportsfilters.IsPaid, selected: false },
            { ...reportsfilters.ReportStatus },
            { ...reportsfilters.NotReportStatus },
            { ...reportsfilters.Reason },
            { ...reportsfilters.Alerts },
            {
              ...reportsfilters.Profile,
              OptionsAsync: ProfileService.allMapped,
              isTransferOnly: false,
              searchRemote: true
            },
            { ...reportsfilters.Driver },
            {
              ...reportsfilters.VehicleOwner,
              OptionsAsync: ProfileService.allMapped,
            },
            {
              ...reportsfilters.TransferStatusWNotTransferred,
              selected: [11],
            },
            {
              ...reportsfilters.DriverTransferStatusWNotTransferred,
              Display: "סטטוס הסבת עובד",
              Query: "DriverTransferStatus",
              Tooltip: 'סטטוס ההסבה של עובד ע"פ המערכת',
            },
            { ...reportsfilters.ReportNumber },
            { ...reportsfilters.MuniIdNumber },
            { ...reportsfilters.PostOfficeReference },
            {
              ...reportsfilters.PlateNumber,
              selected: this.$route.query.PlateNumber,
              OptionsAsync: (term) =>
                VehicleService.searchAdminPlateNumber(term).then((r) =>
                  r.data.map((s) => ({ Text: s.Name, Value: s.Name }))
                ),
            },
            { ...reportsfilters.Municipality },
            {
              ...reportsfilters.DateTypes,
              selected: FilterService.DateSearchTypes.DateTaken,
              Options: this.isLeasingCompany
                ? this.adminDateTypeOptions
                : [
                  { ...FilterService.DateSearchTypes.DateTaken },
                  { ...FilterService.DateSearchTypes.LastPayDate },
                  { ...FilterService.DateSearchTypes.PaymentDate },
                  { ...FilterService.DateSearchTypes.ApprovalDate },
                  { ...FilterService.DateSearchTypes.VerificationDate },
                  { ...FilterService.DateSearchTypes.CreateDate },
                  {
                    ...FilterService.DateSearchTypes
                      .FirstDocumentTransferCompleteDate,
                  },
                  {
                    ...FilterService.DateSearchTypes
                      .FirstDocumentTransferDriverCompleteDate,
                  },
                ],
            },
          ],
          sortField: "LastPayDate",
          sortOrder: "asc",
          checkableRows: true,
          excelExport,
          fastSearch: true,
          fastSearchOptions: {
            propName: "ReportNumber",
            label: "חיפוש לפי מספר דוח",
          },
          sideViewEntity,
          tableActions: [
            TableActions.markAsPaid,
            TableActions.driverAssign,
            {
              ...TableActions.changeTransferStatusCompanyAdmin,
              Label: "שינוי סטטוס הסבת לקוח",
            },
            {
              ...TableActions.changeTransferStatusDriver,
              Label: "שינוי סטטוס הסבת עובד",
            },
            TableActions.changeReportStatus,
            TableActions.reportsDetailsScanning,
            TableActions.reportsAlertsGenerator,
          ],
          isAdminArea: true,
          defaultQuery: {
            IsAscending: true,
            SortedBy: "LastPayDate",
            TransferStatus: [11],
            tab: "ReportsTransferCompanyViaMail"
          }
        },
        {
          id: "ReportsTransferDriverViaMail",
          title: "דוחות ממתינים לשליחה בדואר לפי סטטוס הסבת עובד",
          newEntityComponent: NewReportEntity,
          getDataAsync: this.getAllReports,
          perPage: 20,
          fields: transfersFields,
          isTransferContext: true,
          filters: [
            { ...reportsfilters.IsPaid, selected: false },
            { ...reportsfilters.ReportStatus },
            { ...reportsfilters.NotReportStatus },
            { ...reportsfilters.Reason },
            { ...reportsfilters.Alerts },
            {
              ...reportsfilters.Profile,
              OptionsAsync: ProfileService.allMapped,
              isTransferOnly: false,
              searchRemote: true
            },
            { ...reportsfilters.Driver },
            {
              ...reportsfilters.VehicleOwner,
              OptionsAsync: ProfileService.allMapped,
            },
            {
              ...reportsfilters.TransferStatusWNotTransferred,
            },
            {
              ...reportsfilters.DriverTransferStatusWNotTransferred,
              selected: [11],
              Display: "סטטוס הסבת עובד",
              Query: "DriverTransferStatus",
              Tooltip: 'סטטוס ההסבה של עובד ע"פ המערכת',
            },
            { ...reportsfilters.ReportNumber },
            { ...reportsfilters.MuniIdNumber },
            { ...reportsfilters.PostOfficeReference },
            {
              ...reportsfilters.PlateNumber,
              selected: this.$route.query.PlateNumber,
              OptionsAsync: (term) =>
                VehicleService.searchAdminPlateNumber(term).then((r) =>
                  r.data.map((s) => ({ Text: s.Name, Value: s.Name }))
                ),
            },
            { ...reportsfilters.Municipality },
            {
              ...reportsfilters.DateTypes,
              selected: FilterService.DateSearchTypes.DateTaken,
              Options: this.isLeasingCompany
                ? this.adminDateTypeOptions
                : [
                  { ...FilterService.DateSearchTypes.DateTaken },
                  { ...FilterService.DateSearchTypes.LastPayDate },
                  { ...FilterService.DateSearchTypes.PaymentDate },
                  { ...FilterService.DateSearchTypes.ApprovalDate },
                  { ...FilterService.DateSearchTypes.VerificationDate },
                  { ...FilterService.DateSearchTypes.CreateDate },
                  {
                    ...FilterService.DateSearchTypes
                      .FirstDocumentTransferCompleteDate,
                  },
                  {
                    ...FilterService.DateSearchTypes
                      .FirstDocumentTransferDriverCompleteDate,
                  },
                ],
            },
          ],
          sortField: "LastPayDate",
          sortOrder: "asc",
          checkableRows: true,
          excelExport,
          fastSearch: true,
          fastSearchOptions: {
            propName: "ReportNumber",
            label: "חיפוש לפי מספר דוח",
          },
          sideViewEntity,
          tableActions: [
            TableActions.markAsPaid,
            TableActions.driverAssign,
            {
              ...TableActions.changeTransferStatusCompanyAdmin,
              Label: "שינוי סטטוס הסבת לקוח",
            },
            {
              ...TableActions.changeTransferStatusDriver,
              Label: "שינוי סטטוס הסבת עובד",
            },
            TableActions.changeReportStatus,
            TableActions.reportsDetailsScanning,
            TableActions.reportsAlertsGenerator,
          ],
          isAdminArea: true,
          defaultQuery: {
            IsAscending: true,
            SortedBy: "LastPayDate",
            DriverTransferStatus: [11],
            tab: "ReportsTransferDriverViaMail"
          }
        },
        {
          id: "TransferCompanySendingProcessAdmin",
          title: "הסבות לקוח לשידור",
          newEntityComponent: NewReportEntity,
          getDataAsync: this.getAllTransfers,
          perPage: 20,
          // fields,
          fields: this.displayFields(
            [...transfersFields, { ...reportsFields.TransferCount, checked: true }],
            [
              "סטטוס הסבת לקוח",
              "תאריך הפקת הסבת לקוח",
              "קובץ הסבה ללקוח",
              "חברה",
              "לקוח",
            ],
            ["סטטוס הסבת עובד", "תאריך הפקת הסבת עובד", "קובץ הסבת עובד", "עובד"]
          ),
          isTransferContext: true,
          filters: [
            { ...reportsfilters.IsPaid, selected: false },
            { ...reportsfilters.ReportStatus },
            { ...reportsfilters.NotReportStatus },
            { ...reportsfilters.Reason },
            { ...reportsfilters.Alerts },
            {
              ...reportsfilters.Profile,
              OptionsAsync: ProfileService.allMapped,
              isTransferOnly: false,
              searchRemote: true
            },
            { ...reportsfilters.Driver },
            {
              ...reportsfilters.VehicleOwner,
              OptionsAsync: ProfileService.allMapped,
            },
            {
              ...reportsfilters.TransferStatusWNotTransferred,
              selected: [10],
            },
            {
              ...reportsfilters.DriverTransferStatusWNotTransferred,
              Display: "סטטוס הסבת עובד",
              Query: "DriverTransferStatus",
              Tooltip: 'סטטוס ההסבה של עובד ע"פ המערכת',
            },
            { ...reportsfilters.ReportNumber },
            { ...reportsfilters.MuniIdNumber },
            { ...reportsfilters.PostOfficeReference },
            {
              ...reportsfilters.PlateNumber,
              selected: this.$route.query.PlateNumber,
              OptionsAsync: (term) =>
                VehicleService.searchAdminPlateNumber(term).then((r) =>
                  r.data.map((s) => ({ Text: s.Name, Value: s.Name }))
                ),
            },
            { ...reportsfilters.Municipality },
            {
              ...reportsfilters.DateTypes,
              selected: FilterService.DateSearchTypes.DateTaken,
              Options: this.isLeasingCompany
                ? this.adminDateTypeOptions
                : [
                  { ...FilterService.DateSearchTypes.DateTaken },
                  { ...FilterService.DateSearchTypes.LastPayDate },
                  { ...FilterService.DateSearchTypes.PaymentDate },
                  { ...FilterService.DateSearchTypes.ApprovalDate },
                  { ...FilterService.DateSearchTypes.VerificationDate },
                  { ...FilterService.DateSearchTypes.CreateDate },
                  {
                    ...FilterService.DateSearchTypes
                      .FirstDocumentTransferCompleteDate,
                  },
                  {
                    ...FilterService.DateSearchTypes
                      .FirstDocumentTransferDriverCompleteDate,
                  },
                ],
            },
          ],
          sortField: "LastPayDate",
          sortOrder: "asc",
          checkableRows: true,
          excelExport,
          fastSearch: true,
          fastSearchOptions: {
            propName: "ReportNumber",
            label: "חיפוש לפי מספר דוח",
          },
          sideViewEntity,
          tableActions: [
            TableActions.markAsPaid,
            TableActions.driverAssign,
            {
              ...TableActions.changeTransferStatusCompanyAdmin,
              Label: "שינוי סטטוס הסבת לקוח",
            },
            // {
            //   ...TableActions.changeTransferStatusDriver,
            //   Label: "שינוי סטטוס הסבת עובד",
            // },
            TableActions.changeReportStatus,
            TableActions.reportsDetailsScanning,
            TableActions.reportsAlertsGenerator,
          ],
          isAdminArea: true,
          defaultQuery: {
            IsAscending: true,
            SortedBy: "LastPayDate",
            TransferStatus: [10],
            tab: "TransferCompanySendingProcessAdmin"
          }
        },
        {
          id: "TransferCompanySendAgainAdmin",
          title: "הסבות לקוח ש.חוזר",
          newEntityComponent: NewReportEntity,
          getDataAsync: this.getAllTransfers,
          perPage: 20,
          fields: this.displayFields(
            [...transfersFields, { ...reportsFields.TransferCount, checked: true }],
            [
              "סטטוס הסבת לקוח",
              "תאריך הפקת הסבת לקוח",
              "קובץ הסבה ללקוח",
              "חברה",
              "לקוח",
            ],
            ["סטטוס הסבת עובד", "תאריך הפקת הסבת עובד", "קובץ הסבת עובד", "עובד"]
          ),
          isTransferContext: true,
          filters: [
            { ...reportsfilters.IsPaid, selected: false },
            { ...reportsfilters.ReportStatus },
            { ...reportsfilters.NotReportStatus },
            { ...reportsfilters.Reason },
            { ...reportsfilters.Alerts },
            {
              ...reportsfilters.Profile,
              OptionsAsync: ProfileService.allMapped,
              isTransferOnly: false,
              searchRemote: true
            },
            { ...reportsfilters.Driver },
            {
              ...reportsfilters.VehicleOwner,
              OptionsAsync: ProfileService.allMapped,
            },
            {
              ...reportsfilters.TransferStatusWNotTransferred,
              selected: [9],
            },
            {
              ...reportsfilters.DriverTransferStatusWNotTransferred,
              Display: "סטטוס הסבת עובד",
              Query: "DriverTransferStatus",
              Tooltip: 'סטטוס ההסבה של עובד ע"פ המערכת',
            },
            { ...reportsfilters.ReportNumber },
            { ...reportsfilters.MuniIdNumber },
            { ...reportsfilters.PostOfficeReference },
            {
              ...reportsfilters.PlateNumber,
              selected: this.$route.query.PlateNumber,
              OptionsAsync: (term) =>
                VehicleService.searchAdminPlateNumber(term).then((r) =>
                  r.data.map((s) => ({ Text: s.Name, Value: s.Name }))
                ),
            },
            { ...reportsfilters.Municipality },
            {
              ...reportsfilters.DateTypes,
              selected: FilterService.DateSearchTypes.DateTaken,
              Options: this.isLeasingCompany
                ? this.adminDateTypeOptions
                : [
                  { ...FilterService.DateSearchTypes.DateTaken },
                  { ...FilterService.DateSearchTypes.LastPayDate },
                  { ...FilterService.DateSearchTypes.PaymentDate },
                  { ...FilterService.DateSearchTypes.ApprovalDate },
                  { ...FilterService.DateSearchTypes.VerificationDate },
                  { ...FilterService.DateSearchTypes.CreateDate },
                  {
                    ...FilterService.DateSearchTypes
                      .FirstDocumentTransferCompleteDate,
                  },
                  {
                    ...FilterService.DateSearchTypes
                      .FirstDocumentTransferDriverCompleteDate,
                  },
                ],
            },
          ],
          sortField: "LastPayDate",
          sortOrder: "asc",
          checkableRows: true,
          excelExport,
          fastSearch: true,
          fastSearchOptions: {
            propName: "ReportNumber",
            label: "חיפוש לפי מספר דוח",
          },
          sideViewEntity,
          tableActions: [
            TableActions.markAsPaid,
            TableActions.driverAssign,
            TableActions.addTask,
            {
              ...TableActions.changeTransferStatusCompany,
              Label: "שינוי סטטוס הסבת לקוח",
            },
            // {
            //   ...TableActions.changeTransferStatusDriver,
            //   Label: "שינוי סטטוס הסבת עובד",
            // },
            TableActions.changeReportStatus,
            TableActions.reportsDetailsScanning,
            TableActions.reportsAlertsGenerator,
          ],
          isAdminArea: true,
          defaultQuery: {
            IsAscending: true,
            SortedBy: "LastPayDate",
            TransferStatus: [9],
            tab: "TransferCompanySendAgainAdmin"
          }
        },
        {
          id: "TransferCompanyDelayedAdmin",
          title: "הסבות לקוח בהשהייה",
          newEntityComponent: NewReportEntity,
          getDataAsync: this.getAllTransfers,
          perPage: 20,
          fields: this.displayFields(
            [...transfersFields, { ...reportsFields.TransferCount, checked: true }],
            [
              "סטטוס הסבת לקוח",
              "תאריך הפקת הסבת לקוח",
              "קובץ הסבה ללקוח",
              "חברה",
              "לקוח",
            ],
            ["סטטוס הסבת עובד", "תאריך הפקת הסבת עובד", "קובץ הסבת עובד", "עובד"]
          ),
          isTransferContext: true,
          filters: [
            { ...reportsfilters.IsPaid, selected: false },
            { ...reportsfilters.ReportStatus },
            { ...reportsfilters.NotReportStatus },
            { ...reportsfilters.Reason },
            { ...reportsfilters.Alerts },
            {
              ...reportsfilters.Profile,
              OptionsAsync: ProfileService.allMapped,
              isTransferOnly: false,
              searchRemote: true
            },
            { ...reportsfilters.Driver },
            {
              ...reportsfilters.VehicleOwner,
              OptionsAsync: ProfileService.allMapped,
            },
            {
              ...reportsfilters.TransferStatusWNotTransferred,
              selected: [16],
            },
            {
              ...reportsfilters.DriverTransferStatusWNotTransferred,
              Display: "סטטוס הסבת עובד",
              Query: "DriverTransferStatus",
              Tooltip: 'סטטוס ההסבה של עובד ע"פ המערכת',
            },
            { ...reportsfilters.ReportNumber },
            { ...reportsfilters.MuniIdNumber },
            { ...reportsfilters.PostOfficeReference },
            {
              ...reportsfilters.PlateNumber,
              selected: this.$route.query.PlateNumber,
              OptionsAsync: (term) =>
                VehicleService.searchAdminPlateNumber(term).then((r) =>
                  r.data.map((s) => ({ Text: s.Name, Value: s.Name }))
                ),
            },
            { ...reportsfilters.Municipality },
            {
              ...reportsfilters.DateTypes,
              selected: FilterService.DateSearchTypes.DateTaken,
              Options: this.isLeasingCompany
                ? this.adminDateTypeOptions
                : [
                  { ...FilterService.DateSearchTypes.DateTaken },
                  { ...FilterService.DateSearchTypes.LastPayDate },
                  { ...FilterService.DateSearchTypes.PaymentDate },
                  { ...FilterService.DateSearchTypes.ApprovalDate },
                  { ...FilterService.DateSearchTypes.VerificationDate },
                  { ...FilterService.DateSearchTypes.CreateDate },
                  {
                    ...FilterService.DateSearchTypes
                      .FirstDocumentTransferCompleteDate,
                  },
                  {
                    ...FilterService.DateSearchTypes
                      .FirstDocumentTransferDriverCompleteDate,
                  },
                ],
            },
          ],
          sortField: "LastPayDate",
          sortOrder: "asc",
          checkableRows: true,
          excelExport,
          fastSearch: true,
          fastSearchOptions: {
            propName: "ReportNumber",
            label: "חיפוש לפי מספר דוח",
          },
          sideViewEntity,
          tableActions: [
            TableActions.markAsPaid,
            TableActions.driverAssign,
            TableActions.addTask,
            {
              ...TableActions.changeTransferStatusCompanyAdmin,
              Label: "שינוי סטטוס הסבת לקוח",
            },
            // {
            //   ...TableActions.changeTransferStatusDriver,
            //   Label: "שינוי סטטוס הסבת עובד",
            // },
            TableActions.changeReportStatus,
            TableActions.reportsDetailsScanning,
            TableActions.reportsAlertsGenerator,
          ],
          isAdminArea: true,
          defaultQuery: {
            IsAscending: true,
            SortedBy: "LastPayDate",
            TransferStatus: [16],
            tab: "TransferCompanyDelayedAdmin"
          }
        },
        {
          id: "TransferDriversSendingProcessAdmin",
          title: "הסבות עובדים לשידור",
          newEntityComponent: NewReportEntity,
          getDataAsync: this.getAllReports,
          perPage: 20,
          fields: this.displayFields(
            [...reportFields, { ...reportsFields.TransferCount, checked: true }],
            [
              "סטטוס הסבת עובד",
              "תאריך הפקת הסבת עובד",
              "קובץ הסבת עובד",
              "חברה",
              "לקוח",
              "עובד",
            ],
            ["סטטוס הסבת לקוח", "תאריך הפקת הסבת לקוח", "קובץ הסבה ללקוח"]
          ),
          filters: [
            { ...reportsfilters.IsPaid, selected: false },
            { ...reportsfilters.ReportStatus },
            { ...reportsfilters.NotReportStatus },
            { ...reportsfilters.Reason },
            { ...reportsfilters.Alerts },
            {
              ...reportsfilters.Profile,
              OptionsAsync: ProfileService.allMapped,
              isTransferOnly: false,
              searchRemote: true
            },
            { ...reportsfilters.Driver },
            {
              ...reportsfilters.VehicleOwner,
              OptionsAsync: ProfileService.allMapped,
            },
            {
              ...reportsfilters.TransferStatusWNotTransferred,
            },
            {
              ...reportsfilters.DriverTransferStatusWNotTransferred,
              selected: [10],
              Display: "סטטוס הסבת עובד",
              Query: "DriverTransferStatus",
              Tooltip: 'סטטוס ההסבה של עובד ע"פ המערכת',
            },
            { ...reportsfilters.ReportNumber },
            { ...reportsfilters.MuniIdNumber },
            { ...reportsfilters.PostOfficeReference },
            {
              ...reportsfilters.PlateNumber,
              selected: this.$route.query.PlateNumber,
              OptionsAsync: (term) =>
                VehicleService.searchAdminPlateNumber(term).then((r) =>
                  r.data.map((s) => ({ Text: s.Name, Value: s.Name }))
                ),
            },
            { ...reportsfilters.Municipality },
            {
              ...reportsfilters.DateTypes,
              selected: FilterService.DateSearchTypes.DateTaken,
              Options: this.isLeasingCompany
                ? this.adminDateTypeOptions
                : [
                  { ...FilterService.DateSearchTypes.DateTaken },
                  { ...FilterService.DateSearchTypes.LastPayDate },
                  { ...FilterService.DateSearchTypes.PaymentDate },
                  { ...FilterService.DateSearchTypes.ApprovalDate },
                  { ...FilterService.DateSearchTypes.VerificationDate },
                  { ...FilterService.DateSearchTypes.CreateDate },
                  {
                    ...FilterService.DateSearchTypes
                      .FirstDocumentTransferCompleteDate,
                  },
                  {
                    ...FilterService.DateSearchTypes
                      .FirstDocumentTransferDriverCompleteDate,
                  },
                ],
            },
          ],
          sortField: "LastPayDate",
          sortOrder: "asc",
          checkableRows: true,
          excelExport,
          fastSearch: true,
          fastSearchOptions: {
            propName: "ReportNumber",
            label: "חיפוש לפי מספר דוח",
          },
          sideViewEntity,
          tableActions: [
            TableActions.markAsPaid,
            TableActions.driverAssign,
            // {
            //   ...TableActions.changeTransferStatusCompany,
            //   Label: "שינוי סטטוס הסבת לקוח",
            // },
            {
              ...TableActions.changeTransferStatusDriver,
              Label: "שינוי סטטוס הסבת עובד",
            },
            TableActions.changeReportStatus,
            TableActions.reportsDetailsScanning,
            TableActions.reportsAlertsGenerator,
          ],
          isAdminArea: true,
          defaultQuery: {
            IsAscending: true,
            SortedBy: "LastPayDate",
            DriverTransferStatus: [10],
            tab: "TransferDriversSendingProcessAdmin"
          }
        },
        {
          id: "TransferDriversSendAgainAdmin",
          title: "הסבות עובדים ש.חוזר",
          newEntityComponent: NewReportEntity,
          getDataAsync: this.getAllReports,
          perPage: 20,
          fields: this.displayFields(
            [...reportFields, { ...reportsFields.TransferCount, checked: true }],
            [
              "סטטוס הסבת עובד",
              "תאריך הפקת הסבת עובד",
              "קובץ הסבת עובד",
              "חברה",
              "לקוח",
              "עובד",
            ],
            ["סטטוס הסבת לקוח", "תאריך הפקת הסבת לקוח", "קובץ הסבה ללקוח"]
          ),
          filters: [
            { ...reportsfilters.IsPaid, selected: false },
            { ...reportsfilters.ReportStatus },
            { ...reportsfilters.NotReportStatus },
            { ...reportsfilters.Reason },
            { ...reportsfilters.Alerts },
            {
              ...reportsfilters.Profile,
              OptionsAsync: ProfileService.allMapped,
              isTransferOnly: false,
              searchRemote: true
            },
            { ...reportsfilters.Driver },
            {
              ...reportsfilters.VehicleOwner,
              OptionsAsync: ProfileService.allMapped,
            },
            {
              ...reportsfilters.TransferStatusWNotTransferred,
            },
            {
              ...reportsfilters.DriverTransferStatusWNotTransferred,
              selected: [9],
              Display: "סטטוס הסבת עובד",
              Query: "DriverTransferStatus",
              Tooltip: 'סטטוס ההסבה של עובד ע"פ המערכת',
            },
            { ...reportsfilters.ReportNumber },
            { ...reportsfilters.MuniIdNumber },
            { ...reportsfilters.PostOfficeReference },
            {
              ...reportsfilters.PlateNumber,
              selected: this.$route.query.PlateNumber,
              OptionsAsync: (term) =>
                VehicleService.searchAdminPlateNumber(term).then((r) =>
                  r.data.map((s) => ({ Text: s.Name, Value: s.Name }))
                ),
            },
            { ...reportsfilters.Municipality },
            {
              ...reportsfilters.DateTypes,
              selected: FilterService.DateSearchTypes.DateTaken,
              Options: this.isLeasingCompany
                ? this.adminDateTypeOptions
                : [
                  { ...FilterService.DateSearchTypes.DateTaken },
                  { ...FilterService.DateSearchTypes.LastPayDate },
                  { ...FilterService.DateSearchTypes.PaymentDate },
                  { ...FilterService.DateSearchTypes.ApprovalDate },
                  { ...FilterService.DateSearchTypes.VerificationDate },
                  { ...FilterService.DateSearchTypes.CreateDate },
                  {
                    ...FilterService.DateSearchTypes
                      .FirstDocumentTransferCompleteDate,
                  },
                  {
                    ...FilterService.DateSearchTypes
                      .FirstDocumentTransferDriverCompleteDate,
                  },
                ],
            },
          ],
          sortField: "LastPayDate",
          sortOrder: "asc",
          checkableRows: true,
          excelExport,
          fastSearch: true,
          fastSearchOptions: {
            propName: "ReportNumber",
            label: "חיפוש לפי מספר דוח",
          },
          sideViewEntity,
          tableActions: [
            TableActions.markAsPaid,
            TableActions.driverAssign,
            TableActions.addTask,
            {
              ...TableActions.changeTransferStatusDriverAdmin,
              Label: "שינוי סטטוס הסבת עובד",
            },
            TableActions.changeReportStatus,
            TableActions.reportsDetailsScanning,
            TableActions.reportsAlertsGenerator,
          ],
          isAdminArea: true,
          defaultQuery: {
            IsAscending: true,
            SortedBy: "LastPayDate",
            DriverTransferStatus: [9],
            tab: "TransferDriversSendAgainAdmin"
          }
        },
        {
          id: "TransferDriversDelayedAdmin",
          title: "הסבות עובדים בהשהייה",
          newEntityComponent: NewReportEntity,
          getDataAsync: this.getAllReports,
          perPage: 20,
          fields: this.displayFields(
            [...reportFields, { ...reportsFields.TransferCount, checked: true }],
            [
              "סטטוס הסבת עובד",
              "תאריך הפקת הסבת עובד",
              "קובץ הסבת עובד",
              "חברה",
              "לקוח",
              "עובד",
            ],
            ["סטטוס הסבת לקוח", "תאריך הפקת הסבת לקוח", "קובץ הסבה ללקוח"]
          ),
          filters: [
            { ...reportsfilters.IsPaid, selected: false },
            { ...reportsfilters.ReportStatus },
            { ...reportsfilters.NotReportStatus },
            { ...reportsfilters.Reason },
            { ...reportsfilters.Alerts },
            {
              ...reportsfilters.Profile,
              OptionsAsync: ProfileService.allMapped,
              isTransferOnly: false,
              searchRemote: true
            },
            { ...reportsfilters.Driver },
            {
              ...reportsfilters.VehicleOwner,
              OptionsAsync: ProfileService.allMapped,
            },
            {
              ...reportsfilters.TransferStatusWNotTransferred,
            },
            {
              ...reportsfilters.DriverTransferStatusWNotTransferred,
              selected: [16],
              Display: "סטטוס הסבת עובד",
              Query: "DriverTransferStatus",
              Tooltip: 'סטטוס ההסבה של עובד ע"פ המערכת',
            },
            { ...reportsfilters.ReportNumber },
            { ...reportsfilters.MuniIdNumber },
            { ...reportsfilters.PostOfficeReference },
            {
              ...reportsfilters.PlateNumber,
              selected: this.$route.query.PlateNumber,
              OptionsAsync: (term) =>
                VehicleService.searchAdminPlateNumber(term).then((r) =>
                  r.data.map((s) => ({ Text: s.Name, Value: s.Name }))
                ),
            },
            { ...reportsfilters.Municipality },
            {
              ...reportsfilters.DateTypes,
              selected: FilterService.DateSearchTypes.DateTaken,
              Options: this.isLeasingCompany
                ? this.adminDateTypeOptions
                : [
                  { ...FilterService.DateSearchTypes.DateTaken },
                  { ...FilterService.DateSearchTypes.LastPayDate },
                  { ...FilterService.DateSearchTypes.PaymentDate },
                  { ...FilterService.DateSearchTypes.ApprovalDate },
                  { ...FilterService.DateSearchTypes.VerificationDate },
                  { ...FilterService.DateSearchTypes.CreateDate },
                  {
                    ...FilterService.DateSearchTypes
                      .FirstDocumentTransferCompleteDate,
                  },
                  {
                    ...FilterService.DateSearchTypes
                      .FirstDocumentTransferDriverCompleteDate,
                  },
                ],
            },
          ],
          sortField: "LastPayDate",
          sortOrder: "asc",
          checkableRows: true,
          excelExport,
          fastSearch: true,
          fastSearchOptions: {
            propName: "ReportNumber",
            label: "חיפוש לפי מספר דוח",
          },
          sideViewEntity,
          tableActions: [
            TableActions.markAsPaid,
            TableActions.driverAssign,
            TableActions.addTask,
            // {
            //   ...TableActions.changeTransferStatusCompany,
            //   Label: "שינוי סטטוס הסבת לקוח",
            // },
            {
              ...TableActions.changeTransferStatusDriver,
              Label: "שינוי סטטוס הסבת עובד",
            },
            TableActions.changeReportStatus,
            TableActions.reportsDetailsScanning,
            TableActions.reportsAlertsGenerator,
          ],
          isAdminArea: true,
          defaultQuery: {
            IsAscending: true,
            SortedBy: "LastPayDate",
            DriverTransferStatus: [16],
            tab: "TransferDriversDelayedAdmin"
          }
        },
        {
          id: "TransfersClarificationStatusAdmin",
          title: "הסבות לבירור סטטוס",
          getDataAsync: this.getReportsForClarificationAdmin,
          perPage: 20,
          fields: allReportFields.map((f) => (f.Id === 'LastSendingDate' ? { ...f, checked: true } : f)),
          filters: [
            { ...reportsfilters.ReportStatus },
            { ...reportsfilters.NotReportStatus, selected: [0] },
            { ...reportsfilters.Reason },
            { ...reportsfilters.Alerts },
            {
              ...reportsfilters.Profile,
              OptionsAsync: ProfileService.allMapped,
              isTransferOnly: false,
              searchRemote: true
            },
            { ...reportsfilters.Driver },
            { ...reportsfilters.ReportNumber },
            { ...reportsfilters.MuniIdNumber },
            {
              ...reportsfilters.PlateNumber,
              selected: this.$route.query.PlateNumber,
              OptionsAsync: (term) =>
                VehicleService.searchAdminPlateNumber(term).then((r) =>
                  r.data.map((s) => ({ Text: s.Name, Value: s.Name }))
                ),
            },
            { ...reportsfilters.Municipality },
            {
              ...reportsfilters.VehicleOwner,
              OptionsAsync: ProfileService.allMapped,
            },
            {
              ...reportsfilters.TransferStatusWNotTransferred,
              selected: [3, 4, 5, 7, 8, 15, 19, 24],
            },
            {
              ...reportsfilters.DateTypes,
              Options: [{ ...FilterService.DateSearchTypes.LastSendingDate }],
            },
          ],
          sortField: "Id",
          sortOrder: "desc",
          checkableRows: true,
          fastSearch: true,
          fastSearchOptions: {
            propName: "ReportNumber",
            label: "חיפוש לפי מספר דוח",
          },
          sideViewEntity,
          excelExport,
          tableActions: [
            TableActions.markAsPaid,
            TableActions.driverAssign,
            TableActions.downloadFiles,
            TableActions.addTask,
            {
              ...TableActions.changeTransferStatusCompanyAdmin,
              Label: "שינוי סטטוס הסבת לקוח",
            },
            {
              ...TableActions.changeTransferStatusDriver,
              Label: "שינוי סטטוס הסבת עובד",
            },
            TableActions.changeReportStatus,
            TableActions.reportsDetailsScanning,
            TableActions.reportsAlertsGenerator,
          ],
          isAdminArea: true,
          defaultQuery: {
            tab: "TransfersClarificationStatusAdmin"
          }
        },
      ];
    },
    async onPlateNumberClick(context) {
      context.default();
    },
    showNewEntity() {
      this.$refs.entity.newEntityMenu();
    },
    onNewEntitySave() {
      this.$refs.entity.onNewEntityCancel();
    },
    export({ loading, query }) {
      loading(true);
      ReportService.exportXslAdmin(query)
        .then((r) => {
          // Check headers in multiple ways (axios normalizes to lowercase)
          const contentType = r.headers && (r.headers["content-type"] || r.headers["Content-Type"]);
          let extension = "xlsx";
          let mimetype = this.excelMimeType;
          if (contentType && contentType.toLowerCase().includes("text/csv")) {
            extension = "csv";
            mimetype = "text/csv";
          }
          this.saveFile(r.data, "יצוא דוחות ממערכת Betterway", extension, mimetype);
        })
        .finally(() => {
          loading(false);
        });
    },
    exportByMunic({ loading, query }) {
      loading(true);
      ReportService.exportXsl(query, "Municipalities")
        .then((r) => {
          // Check headers in multiple ways (axios normalizes to lowercase)
          const contentType = r.headers && (r.headers["content-type"] || r.headers["Content-Type"]);
          let extension = "xlsx";
          let mimetype = this.excelMimeType;
          if (contentType && contentType.toLowerCase().includes("text/csv")) {
            extension = "csv";
            mimetype = "text/csv";
          }
          this.saveFile(r.data, "יצוא דוחות ממערכת Betterway מקובץ לפי עיריות", extension, mimetype);
        })
        .catch((error) => {
          this.$buefy.toast.open({
            type: "is-danger",
            message: error.response.data.ErrorMessage || "קרתה תקלה לא היה ניתן לבצע את הפעולה",
            duration: 8000,
          });
        })
        .finally(() => {
          loading(false);
        });
    },
    exportByClient({ loading, query }) {
      loading(true);
      ReportService.exportXsl(query, "Profiles")
        .then((r) => {
          // Check headers in multiple ways (axios normalizes to lowercase)
          const contentType = r.headers && (r.headers["content-type"] || r.headers["Content-Type"]);
          let extension = "xlsx";
          let mimetype = this.excelMimeType;
          if (contentType && contentType.toLowerCase().includes("text/csv")) {
            extension = "csv";
            mimetype = "text/csv";
          }
          this.saveFile(r.data, "יצוא דוחות ממערכת Betterway מקובץ לפי לקוחות", extension, mimetype);
        })
        .catch((error) => {
          this.$buefy.toast.open({
            type: "is-danger",
            message: error.response.data.ErrorMessage || "קרתה תקלה לא היה ניתן לבצע את הפעולה",
            duration: 8000,
          });
        })
        .finally(() => {
          loading(false);
        });
    },
    getAllReports({ cancelToken, ...rest }) {
      return ReportService.adminSearch(
        {
          ...rest,
        },
        cancelToken.token
      );
    },
    getAllTransfers({ cancelToken, ...rest }) {
      return ReportService.adminSearchTransfers(
        {
          ...rest,
        },
        cancelToken.token
      );
    },
    getReportsForClarificationAdmin({ cancelToken, setPermanentQuery, ...rest }) {
      const query = { IsPaid: false, FilterBySendingDate: true };
      setPermanentQuery(query);
      return ReportService.adminSearch(
        {
          ...rest,
          ...query,
        },
        cancelToken.token
      );
    },
    getPayments({ cancelToken }) {
      return ReportService.getPayments(cancelToken.token).then((r) => ({
        data: {
          TotalResults: r.data.length,
          Items: r.data,
        },
      }));
    },
    getTotalRecords(slotProps) {
      return slotProps.tab && slotProps.tab.total && slotProps.tab.total;
    },
    saveFile(data, filename, extension = "xlsx", mimetype = null) {
      const blobType = mimetype || this.excelMimeType;
      const blob = new Blob([data], { type: blobType });
      saveAs(blob, `${filename}.${extension}`);
    },
    checkFields(fields, idxFieldToCheck) {
      const newFields = [...fields];
      newFields.splice(idxFieldToCheck, 1, {
        ...newFields[idxFieldToCheck],
        checked: true,
      });
      return newFields;
    },
    displayFields(fields, fieldsDisplayTrueArr, fieldsDisplayFalseArr) {
      const newFields = [...fields];
      newFields.forEach((field, idx) => {
        if (fieldsDisplayTrueArr.includes(field.Display)) {
          newFields.splice(idx, 1, {
            ...newFields[idx],
            checked: true,
          });
        }
        if (fieldsDisplayFalseArr.includes(field.Display)) {
          newFields.splice(idx, 1, {
            ...newFields[idx],
            checked: false,
          });
        }
      });
      return newFields;
    },
    addTask() {
      Modal.open({
        component: DialogAddTask,
        props: {
          reportNumbers: [{ Id: 1, reportNumber: 123 }, { Id: 2, reportNumber: 3456 }],
          store: this.$store
        },
        canCancel: false,
        hasModalCard: true,
        trapFocus: true,
      });
    }
  },
  watch: {
    isReady(value) {
      if (value) {
        this.create();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.Reports__View {
  height: 100%;

  .link-button {
    background: #ff7a59;
    border: none;
    border-radius: 3px;
    padding: 14px 25px;
    margin-left: 10px;
    color: white;
    cursor: pointer;
  }
}
</style>
